import React, { useState } from 'react';

type PasswordValidationProps = {
    password: string;
    setPassword: (password: string) => void;
    isValid: boolean;
    setIsValid: (isValid: boolean) => void;
    className?: any;
    touched: boolean;
    setTouched: (touched: boolean) => void;
};

const PasswordValidation = ({
    password,
    setPassword,
    isValid,
    setIsValid,
    className = {
        parentDiv: "w-full text-sm relative",
        label: "w-full text-start block text-blue-500 text-xs",
        input: "w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-blue-500 pr-10",
    },
    touched,
    setTouched

}: PasswordValidationProps) => {
    const [passwordTextType, setPasswordTextType] = useState<boolean>(false);
    const [isPasswordFocused, setIsPasswordFocused] = useState<boolean>(false);

    const togglePasswordVisibility = () => {
        setPasswordTextType(!passwordTextType);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPassword(value);
        setTouched(true);

        const isValidPassword =
            value.length >= 8 &&
            /\d/.test(value) &&
            /[a-z]/.test(value) &&
            /[A-Z]/.test(value) &&
            /[!@#$%^&*(),.?":{}|<>]/.test(value);

        setIsValid(isValidPassword);

        if (!isValidPassword && isPasswordFocused) {
            e.target.setCustomValidity("Password must be at least 8 characters long and include at least one lowercase letter (a-z), one uppercase letter (A-Z), one number (0-9), and one special character (!@#$%^&*()).");
        } else {
            e.target.setCustomValidity("");
        }
    };

    return (
        <div className={className.parentDiv}>
            <label htmlFor="password" className={className.label}>
                Password
            </label>
            <div className="flex items-center">
                <input
                    name="password"
                    type={passwordTextType ? 'text' : 'password'}
                    className={className.input}
                    placeholder="Enter Password"
                    value={password}
                    onChange={handleChange}
                    autoComplete="new-password"
                    onFocus={() => setIsPasswordFocused(true)}
                    onBlur={() => setIsPasswordFocused(false)}
                />

                {
                    passwordTextType ? <span className="material-symbols-outlined text-gray-500 absolute right-3 cursor-pointer text-lg" onClick={togglePasswordVisibility}>
                        visibility_off
                    </span> : <span className="material-symbols-outlined text-gray-500 absolute right-3 cursor-pointer text-lg" onClick={togglePasswordVisibility}>
                        visibility
                    </span>
                }
            </div>

            {!isValid && touched && (
                <div className="flex items-center mt-2 text-xs text-red-500">
                    <span>
                        Password must be at least 8 characters long and include at least one lowercase letter (a-z),
                        one uppercase letter (A-Z),
                        one number (0-9),
                        and one special character (!@#$%^&*()).
                    </span>
                </div>
            )}
        </div>
    );
};

export default PasswordValidation;